export default __webpack_public_path__ + "static/media/Ghostweave Drape.56b381f8.jpg";